import { ValidationConfigurator } from "./../ValidationConfigurator";

import "./bootstrap-notify-settings";
ValidationConfigurator.init();
